// utils/localStorageDraft.js

export function saveDraft(key, data) {
  localStorage.setItem(key, JSON.stringify(data));
}

export function loadDraft(key) {
  const raw = localStorage.getItem(key);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function clearDraft(key) {
  localStorage.removeItem(key);
}
